import { WSAlert, WSAlertProps } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";

function countErrors(errObj: any) {
  // count the number of errors(including deeply nested) in the object and return the count
  let count = 0;
  for (const key in errObj) {
    if (
      typeof errObj[key] === "object" &&
      errObj[key]["message"] === undefined // check if it's not a message object
    ) {
      count += countErrors(errObj[key]);
    } else {
      count++;
    }
  }
  return count;
}

interface Props extends WSAlertProps {}

export const WSFormErrorSummary: React.FC<Props> = props => {
  const { errors } = useFormContext();

  const errorsCount = useMemo(() => countErrors(errors), [errors]);

  return errorsCount > 0 ? (
    <WSAlert
      {...props}
      theme="error"
      icon="info-circle"
      title="Incomplete fields"
      data-testid="ws-form-error-summary"
    >
      There{" "}
      {errorsCount === 1
        ? `is ${errorsCount} incomplete field`
        : `are ${errorsCount} incomplete fields`}
      . All required fields must be complete to continue.
    </WSAlert>
  ) : null;
};
